import(/* webpackMode: "eager", webpackExports: ["default"] */ "D:\\medallion-homes\\node_modules\\@mui\\icons-material\\esm\\ArrowForward.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "D:\\medallion-homes\\node_modules\\@mui\\material\\Box\\Box.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "D:\\medallion-homes\\node_modules\\@mui\\material\\Breadcrumbs\\Breadcrumbs.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "D:\\medallion-homes\\node_modules\\@mui\\material\\Container\\Container.js");
;
import(/* webpackMode: "eager" */ "D:\\medallion-homes\\node_modules\\@mui\\material\\Grid2\\Grid2.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "D:\\medallion-homes\\node_modules\\@mui\\material\\Stack\\Stack.js");
;
import(/* webpackMode: "eager" */ "D:\\medallion-homes\\node_modules\\next\\dist\\client\\app-dir\\link.js");
;
import(/* webpackMode: "eager" */ "D:\\medallion-homes\\node_modules\\next\\dist\\client\\image-component.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "D:\\medallion-homes\\src\\app\\components\\HavanAwardSection.tsx");
